import { inject, Injectable, Injector } from '@angular/core';
import { Router, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class OmniInsightsTitleService {
  private readonly injector = inject(Injector);

  private submenu: string | null = null;
  private refreshing = false;

  setSubmenu(submenu: string | null): void {
    if (this.submenu === submenu) {
      return;
    }
    this.submenu = submenu;
    this.refreshTitle();
  }

  clearSubmenu(): void {
    this.submenu = null;
  }

  getSubmenu(): string | null {
    return this.submenu;
  }

  refreshTitle(): void {
    if (this.refreshing) {
      return;
    }
    this.refreshing = true;
    try {
      const router = this.injector.get(Router);
      this.injector
        .get(TitleStrategy)
        .updateTitle(router.routerState.snapshot);
    } finally {
      this.refreshing = false;
    }
  }
}
